<template>
  <div :class="[loading ? 'loading' : 'loading loaded']">
    <img src="/imgs/loading.gif" alt="">
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'loading',
  computed: mapState([
    'loading'
  ])
}
</script>

<style lang="scss">
  .loading {
    height: 100%;
    width: 100%;
    position: absolute;
    background-color: #fff;
    background-image: url(/imgs/background_quiz.jpg);
    opacity: 0.8;
    top: 0;
    left: 0;

    transition: opacity 2s ease-in-out;

    z-index: 10000;
    img {
      width: 100px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -50px;
      margin-top: -50px;
    }
    &.loaded {
      opacity: 0;
      z-index: -1;
    }
  }

</style>